import type { Type_ILocation } from '../Type/Type.hive'

export function Loca_extractAddress({ address1, address2, postCode, city }: Type_ILocation) {
    return [address1, address2, postCode, city].filter(Boolean).join(', ')
}
